import Axios from 'axios'
import api from '@/services/api'
export default {
    namespaced: true,
    state: {
        party: [],
    },

    getters: {

    },

    mutations: {
        setParty: ( state , party) => {
            state.party = party
            state.party.push({})
            state.party.splice(-1,1)
            console.log(state.party)
        }
    },
    actions: {
        fetchParty: async({commit}) =>{
            let party= (await Axios.get(api.baseUrl + 'party')).data
            commit('setParty', party)
        }
    },
}